// import React, {useEffect, useState} from 'react';
// import Box from '@mui/material/Box';
// import Drawer from '@mui/material/Drawer';
// import sqlcode_icon from '../../../Assets/svgs/sql-server.svg';
// import styles from './SqlQueryComponent.module.css';
// import {Tooltip} from '@mui/material';

// const SqlDrawer = ({msg}: any) => {
// 	const [open, setOpen] = useState(false);
// 	const [sqlQuery, setSqlQuery] = useState('');
// 	const [actualQuery, setActualQuery] = useState<any>([]);
// 	const toggleDrawer = (newOpen: boolean) => () => {
// 		setOpen(newOpen);
// 	};
// 	const errorTraced = msg.errorStatus;
// 	useEffect(() => {
// 		if (msg && msg?.agent_metadata[0] && msg?.agent_metadata[0]?.sql) {
// 			const sql_array = msg?.agent_metadata[0]?.sql;
// 			const sql_query = sql_array[sql_array.length - 1]?.tool_input.query
// 				? sql_array[sql_array.length - 1]?.tool_input.query
// 				: '';
// 			setSqlQuery(sql_query);
// 		}
// 	}, []);

// 	useEffect(() => {
// 		if (
// 			msg &&
// 			msg?.agent_metadata[2] &&
// 			msg?.agent_metadata[2]?.actual_query_executed
// 		) {
// 			const actual_query = msg?.agent_metadata[2]?.actual_query_executed;
// 			setActualQuery(actual_query || []);
// 		}
// 	}, [msg]);

// 	const DrawerList = (
// 		<Box
// 			className={styles.drawer}
// 			role='presentation'
// 			onClick={toggleDrawer(false)}
// 		>
// 			<span className='flex-align-items-center-space-between'>
// 				<h5>SQL Code</h5>
// 				<span className='f12px'>{msg.response_time_in_seconds} sec</span>
// 			</span>
// 			<div>
// 				<h3>Sql Query</h3>
// 				{sqlQuery}
// 				<div className={styles.copyBtn}>
// 					<button onClick={() => navigator.clipboard.writeText(sqlQuery)}>
// 						Copy
// 					</button>
// 				</div>
// 				<div
// 					style={{
// 						color: 'black',
// 						borderBottom: '2px solid black',
// 						padding: '0.5rem',
// 					}}
// 				></div>
// 				<div>
// 					<h3>Actual Query</h3>
// 					{actualQuery?.map((query: string) => {
// 						return <p>{query}</p>;
// 					})}
// 					<div className={styles.copyBtn}>
// 						<button onClick={() => navigator.clipboard.writeText(actualQuery)}>
// 							Copy Actual Query
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</Box>
// 	);
// 	return (
// 		<div style={{display: errorTraced === 500 ? 'none' : 'inline'}}>
// 			<button onClick={toggleDrawer(true)}>
// 				<Tooltip
// 					title='Generate SQL'
// 					placement='top'
// 				>
// 					<img
// 						src={sqlcode_icon}
// 						alt='sql icon'
// 						style={{
// 							maxHeight: '16px',
// 							maxWidth: '16px',
// 							marginRight: '5px',
// 							color: 'blue',
// 						}}
// 					/>
// 				</Tooltip>
// 			</button>
// 			<Drawer
// 				open={open}
// 				onClose={toggleDrawer(false)}
// 				anchor={'right'}
// 			>
// 				{DrawerList}
// 			</Drawer>
// 		</div>
// 	);
// };

// export default React.memo(SqlDrawer);


import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import sqlcode_icon from '../../../Assets/svgs/sql-server.svg';
import styles from './SqlQueryComponent.module.css';
import { Tooltip } from '@mui/material';
import { callLogEvent } from '../../../Common/Util'; 
import { marked } from 'marked';

const SqlDrawer = ({ msg }: any) => {
  const [open, setOpen] = useState(false);
  const [sqlQueries, setSqlQueries] = useState<string[]>([]);
  const [actualQuery, setActualQuery] = useState<any>([]);

  const toggleDrawer = (newOpen: boolean) => () => {
    if (newOpen) {
      (async () => {
        let extra = "";
        try {
          let queryText = "";
          if (msg && typeof msg.question === 'string' && msg.question.trim()) queryText = msg.question.trim();
          if (!queryText && msg && msg.agent_metadata && Array.isArray(msg.agent_metadata) && msg.agent_metadata[0] && msg.agent_metadata[0].sql) {
            const sqlArr = msg.agent_metadata[0].sql;
            const last = sqlArr[sqlArr.length - 1];
            if (last && last.tool_input && last.tool_input.query) queryText = last.tool_input.query;
          }
          if (queryText) {
            try {
              const renderedQ = await Promise.resolve(marked.parse(queryText || ""));
              const tmpQ = document.createElement('div');
              tmpQ.innerHTML = typeof renderedQ === 'string' ? renderedQ : String(renderedQ);
              queryText = (tmpQ.textContent || tmpQ.innerText || '').trim();
            } catch (e) {
              queryText = queryText.replace(/!\[[^\]]*\]\([^)]*\)/g, '').replace(/\[([^\]]+)\]\([^)]*\)/g, '$1').replace(/(```[\s\S]*?```|`[^`]*`)/g, '').replace(/[>#*_~]/g, '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
            }
            if (queryText.length > 200) queryText = queryText.substring(0, 200) + '...';
            extra = ` | Query: ${queryText}`;
          }
        } catch (e) {
          // ignore
        }
        callLogEvent("CLICKED_VIEW_SQL_QUERY", "User opened the SQL query drawer." + (extra || ""));
      })();
    }
    setOpen(newOpen);
  };

  const handleCopyAll = () => {
    try {
      const text = (sqlQueries || []).join('\n\n');
      navigator.clipboard.writeText(text || '');
    } catch (e) {
      // ignore
    }
  };

  const errorTraced = msg.errorStatus;

  useEffect(() => {
    if (msg && msg?.agent_metadata[0] && msg?.agent_metadata[0]?.sql) {
      const sql_array = msg?.agent_metadata[0]?.sql;
      const queries = sql_array.map((item: any) => item?.tool_input?.query || '');
      setSqlQueries(queries);
    }
  }, [msg]);

  useEffect(() => {
    if (
      msg &&
      msg?.agent_metadata[2] &&
      msg?.agent_metadata[2]?.actual_query_executed
    ) {
      const actual_query = msg?.agent_metadata[2]?.actual_query_executed;
      setActualQuery(actual_query || []);
    }
  }, [msg]);

  const DrawerList = (
    <Box className={styles.drawer} role="presentation">
      <span className="flex-align-items-center-space-between">
        <h5>SQL Code</h5>
        <span className="f12px">{msg.response_time_in_seconds} sec</span>
      </span>

      <div>
        <h3>SQL Queries</h3>
        {sqlQueries.map((query, index) => (
            <div key={index} style={{ marginBottom: '1rem' }}>
            <p style={{ color: '#ffffff' }}>{query}</p>
          </div>
        ))}

        {/* Single copy button for all queries */}
        {sqlQueries.length > 0 && (
          <div style={{ marginTop: 8 }}>
            <button onClick={handleCopyAll} style={{ color: '#1e88e5', background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
              Copy All
            </button>
          </div>
        )}

        <div
          style={{
            color: 'black',
            borderBottom: '2px solid black',
            padding: '0.5rem',
          }}
        ></div>

        {/* <div>
          <h3>Actual Query</h3>
          {actualQuery?.map((query: string, index: number) => (
            <p key={index}>{query}</p>
          ))}
          <div className={styles.copyBtn}>
            <button onClick={() => navigator.clipboard.writeText(actualQuery.join('\n'))}>
              Copy Actual Query
            </button>
          </div>
        </div> */}
      </div>
    </Box>
  );

  const codeBoxStyle: React.CSSProperties = {
    background: '#071226',
    color: '#ffffff',
    padding: '1rem',
    borderRadius: '12px',
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace',
    whiteSpace: 'pre-wrap',
    overflowX: 'auto',
  };

  return (
    <div style={{ display: errorTraced === 500 ? 'none' : 'inline' }}>
      <button onClick={toggleDrawer(true)}>
        <Tooltip title="Generate SQL" placement="top">
          <img
            src={sqlcode_icon}
            alt="sql icon"
            style={{
              maxHeight: '16px',
              width: '16px',
              // margin: '0 8px',
              verticalAlign: 'middle',
              background: '#e8f0fe',
              color:'black',
            }}
          />
        </Tooltip>
      </button>

      <Dialog open={open} onClose={toggleDrawer(false)} maxWidth="md" fullWidth>
        <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e8f0fe', borderRadius: 8 }}>
              <img src={sqlcode_icon} alt="sql" style={{ width: 20, height: 20 }} />
            </div>
            <span style={{ fontWeight: 600, fontSize: 18 }}>SQL Query</span>
          </div>
          <IconButton aria-label="close" onClick={toggleDrawer(false)} size="small" style={{ border: '1px solid #dcdcdc' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {sqlQueries.length === 0 ? (
              <div style={{ color: '#666' }}>No SQL queries available.</div>
            ) : (
              <>
                {sqlQueries.map((query, idx) => (
                  <div key={idx}>
                    <div style={codeBoxStyle}>
                      <pre style={{ margin: 0, color: '#ffffff' }}>{query}</pre>
                    </div>
                  </div>
                ))}

                {/* Single Copy All button */}
                <div style={{ marginTop: 12 }}>
                  <button onClick={handleCopyAll} style={{ color: '#1e88e5', background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                    Copy All
                  </button>
                </div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default React.memo(SqlDrawer);

